export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    if (error.message.indexOf('REMISE_BANCAIRE_ACHAT_DELETE_FORBIDDEN_IF_ANY_INVOICES_UNDELETABLE') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.suppressionFacture',
      });
    }
    if (error.message.indexOf('REMISE_BANCAIRE_ACHAT_DELETE_FORBIDDEN_IF_BUY') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.suppressionTypeAchat',
      });
    }
    if (error.message.indexOf('REMISE_BANCAIRE_ACHAT_DELETE_FORBIDDEN_IF_CANCELED_PAYMENT') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.suppressionAnnulation',
      });
    }
    if (error.message.indexOf('REMISE_BANCAIRE_ACHAT_DELETE_FORBIDDEN_IF_VALIDATED') === 0) {
      messages.push({
        message: 'detailLotPaiement.messages.error.suppressionValide',
      });
    }
  });
}
